import { gql } from "@apollo/client";

const UPDATE_USER = gql`
  mutation UpdateUser(
    $id: ID!
    $username: String
    $pseudonym: String
    $picture: String
    $number: String
    $status: ID
    $agentlimitchatassign: Int
    $agentcommentlimit: Int
    $chatbotlimit: Int
    $pages: [String]
    $commentPages: [String]
    $chatbotBots: [String]
    $assignedTwilioNumbers: [String]
    $plans: String
    $mainSuperAdminId: ID
  ) {
    updateuser(
      id: $id
      username: $username
      pseudonym: $pseudonym
      picture: $picture
      number: $number
      status: $status
      agentlimitchatassign: $agentlimitchatassign
      agentcommentlimit: $agentcommentlimit
      chatbotlimit: $chatbotlimit
      pages: $pages
      commentPages: $commentPages
      chatbotBots: $chatbotBots
      assignedTwilioNumbers: $assignedTwilioNumbers
      plans: $plans
      mainSuperAdminId: $mainSuperAdminId
    ) {
      success
      result
      error
    }
  }
`;
export default UPDATE_USER;
